import { Link } from "react-router-dom";
import { Instagram, Youtube, Facebook, Mail, Phone, MapPin } from "lucide-react";
import { BRAND, NAV } from "../data/content";

export default function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-white/5 bg-[#070707]">
      <div className="container-x py-16 md:py-20">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <img
              src={BRAND.logo}
              alt="Ideal Entertainment"
              className="h-12 w-auto object-contain"
            />
            <p className="mt-6 max-w-md text-sm font-light leading-relaxed text-neutral-400">
              {BRAND.mission}
            </p>
            <div className="mt-8 flex gap-4">
              <a href={BRAND.socials.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="grid h-11 w-11 place-items-center rounded-full border border-white/10 text-neutral-300 transition-all hover:border-gold hover:text-gold">
                <Instagram size={18} />
              </a>
              <a href={BRAND.socials.youtube} target="_blank" rel="noreferrer" data-testid="footer-youtube" className="grid h-11 w-11 place-items-center rounded-full border border-white/10 text-neutral-300 transition-all hover:border-gold hover:text-gold">
                <Youtube size={18} />
              </a>
              <a href={BRAND.socials.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="grid h-11 w-11 place-items-center rounded-full border border-white/10 text-neutral-300 transition-all hover:border-gold hover:text-gold">
                <Facebook size={18} />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="overline mb-6">Explore</h4>
            <ul className="space-y-3">
              {NAV.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-sm font-light text-neutral-400 transition-colors hover:text-white"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="overline mb-6">Get in Touch</h4>
            <ul className="space-y-4 text-sm font-light text-neutral-400">
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-gold" />
                <a href={`tel:${BRAND.phone}`} className="hover:text-white">{BRAND.phone}</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-gold" />
                <a href={`mailto:${BRAND.email}`} className="hover:text-white">{BRAND.email}</a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin size={16} className="text-gold" />
                {BRAND.address}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-white/5 pt-8 md:flex-row">
          <p className="text-xs text-neutral-500">
            © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
          </p>
          <p className="text-xs text-neutral-500">
            Connecting people with ideal entertainment.
          </p>
        </div>
      </div>

      <div className="pointer-events-none select-none overflow-hidden">
        <p className="whitespace-nowrap text-center font-playfair text-[18vw] font-bold leading-none text-white/[0.025]">
          IDEAL
        </p>
      </div>
    </footer>
  );
}
